import {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from 'react';
import { getData } from 'src/services/RestApi'; // Adjust the import path as needed

// Create the context
const PaginationContext = createContext();

// Create the provider component
export const PaginationProvider = ({ children, endpoint, keyword }) => {
  const [totalItems, setTotalItems] = useState(0);
  const [refreshPage, setRefreshPage] = useState(false);
  const fetchPayload = useRef(null);
  // const hasFetched = useRef(false);// Ref to track if data has been fetched

  useEffect(() => {
    // Check endpoint, because of the endpoint waiting from another thread
    if (!endpoint) return;

    // Safely create the payload string
    const keywordString = keyword && typeof keyword === 'object' ? JSON.stringify(keyword) : keyword || '';

    // const payload = `${endpoint}?${keywordString}`;
    const payload = keywordString ? `${endpoint}?${encodeURIComponent(keywordString)}` : endpoint;

    // console.log('keywordString A:', payload);
    // console.log('keywordString B:', fetchPayload.current);

    let isRefresh = false;
    if (fetchPayload.current !== payload) {
      // Evaluate whether fetchPayload.current is valid
      const sTemp = !!(fetchPayload.current && fetchPayload.current.trim() !== '');
      isRefresh = sTemp || false;

      // console.log('keywordString ===== A # B', sTemp);
      
      // Update previousEndpoint to the current one
      fetchPayload.current = payload;
      // Call the API since the endpoint is different
      fetchTotalItems();
    }
    setRefreshPage(isRefresh);
  }, [endpoint, keyword]);

  const fetchTotalItems = async () => {
    // Assuming limit 0 means we are querying for total pages
    const payload = { limit: 0 };
    if (keyword) payload.keyword = keyword;

    const { result } = await getData(endpoint, payload);
    let pages = 0;
    if (result && !isNaN(result)) {
      pages = parseInt(result, 10);
    }
    setTotalItems(pages);
  };

  return (
    <PaginationContext.Provider value={{ totalItems, refreshPage }}>
      {children}
    </PaginationContext.Provider>
  );
};

// Custom hook to use the Pagination context
export const usePageList = () => useContext(PaginationContext);
